// extracted by mini-css-extract-plugin
module.exports = {"synopsis":"styles_synopsis__d4z0s"};